"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
require("../css/app.scss");
require("phoenix_html");
const phoenix_1 = require("phoenix");
const phoenix_live_view_1 = require("phoenix_live_view");
require("@github/time-elements");
const ytPlayer_1 = __importDefault(require("./hooks/ytPlayer"));
const submit_1 = __importDefault(require("./hooks/submit"));
const accept_deny_user_1 = __importDefault(require("./hooks/accept_deny_user"));
const denied_access_1 = __importDefault(require("./hooks/denied_access"));
const whereby_loaded_1 = __importDefault(require("./hooks/whereby_loaded"));
const want_in_1 = __importDefault(require("./hooks/want_in"));
const whereby_fullscreen_1 = __importDefault(require("./hooks/whereby_fullscreen"));
const kick_user_1 = __importDefault(require("./hooks/kick_user"));
const room_full_1 = __importDefault(require("./hooks/room_full"));
const open_viewer_1 = __importDefault(require("./hooks/open_viewer"));
require("@popperjs/core");
const bootstrap_min_js_1 = __importDefault(require("bootstrap/dist/js/bootstrap.min.js"));
let csrfToken = (_a = document.querySelector("meta[name='csrf-token']")) === null || _a === void 0 ? void 0 : _a.getAttribute("content");
let liveSocket = new phoenix_live_view_1.LiveSocket("/live", phoenix_1.Socket, {
    params: {
        _csrf_token: csrfToken
    },
    hooks: {
        YTPlayer: ytPlayer_1.default,
        Submit: submit_1.default,
        AcceptDenyUser: accept_deny_user_1.default,
        DeniedAccess: denied_access_1.default,
        WherebyLoaded: whereby_loaded_1.default,
        WantIn: want_in_1.default,
        WherebyFullscreen: whereby_fullscreen_1.default,
        KickUser: kick_user_1.default,
        RoomFull: room_full_1.default,
        OpenVideoChat: open_viewer_1.default
    }
});
window.addEventListener("phx:page-loading-start", () => { });
window.addEventListener("phx:page-loading-stop", () => { });
liveSocket.connect();
window.liveSocket = liveSocket;
document.body.addEventListener("mouseover", (ev) => {
    ev.target.classList.add("hover");
});
document.body.addEventListener("mouseout", (ev) => {
    ev.target.classList.remove("hover");
});
document.querySelectorAll("[data-navigate]").forEach((elem) => {
    elem === null || elem === void 0 ? void 0 : elem.addEventListener("click", () => {
        window.location = elem.getAttribute("data-navigate");
    });
});
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap_min_js_1.default.Tooltip(tooltipTriggerEl);
});
let videoElement = document.getElementById("player");
let chatRoomOpenButton = document.getElementById("open-room-chat");
(_b = document.getElementById("room-chat-hide-button")) === null || _b === void 0 ? void 0 : _b.addEventListener("click", () => {
    videoElement.style.setProperty("height", "100%");
    chatRoomOpenButton.style.setProperty("display", "block");
});
chatRoomOpenButton === null || chatRoomOpenButton === void 0 ? void 0 : chatRoomOpenButton.addEventListener("click", () => {
    videoElement.style.removeProperty("height");
    chatRoomOpenButton.style.setProperty("display", "none");
});
